<ng-container [dynamic]="view()"></ng-container>
